<h1>Oops!</h1>
<p>
    @if (errorMessage){
        {{ errorMessage }}
    }
    @else {
        There was an error loading the page. Please try again, and contact support if this issue persists.
    }
</p>

<button mat-raised-button mgdButton mgdButtonType="save" (click)="onBack()">Go Back</button>